function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Selects table cells on on left & right click.
 */
var SelectionBehavior = function SelectionBehavior(elementRegistry, eventBus, renderer, selection) {
  _classCallCheck(this, SelectionBehavior);

  this._elementRegistry = elementRegistry;
  this._renderer = renderer;
  this._selection = selection;
  eventBus.on(['cell.click', 'cell.contextmenu'], function (_ref) {
    var id = _ref.id;
    var element = elementRegistry.get(id);

    if (!element) {
      return;
    }

    selection.select(element);
  });
  eventBus.on('row.remove', function (_ref2) {
    var row = _ref2.row;
    var currentSelection = selection.get();

    if (!currentSelection) {
      return;
    }

    if (row === currentSelection.row) {
      selection.deselect();
    }
  });
  eventBus.on('col.remove', function (_ref3) {
    var col = _ref3.col;
    var currentSelection = selection.get();

    if (!currentSelection) {
      return;
    }

    if (col === currentSelection.col) {
      selection.deselect();
    }
  });
};

export { SelectionBehavior as default };
SelectionBehavior.$inject = ['elementRegistry', 'eventBus', 'renderer', 'selection'];
//# sourceMappingURL=SelectionBehavior.js.map